// Keeps the export canvas as close to the source's native resolution as reasonable, instead of
// always starting from a fixed baseline - which was silently softening detail (including any
// text baked into the original footage) on anything larger than that baseline, even before the
// user ever touched the crop tool.
const MAX_DIMENSION = 1920

export const capResolution = (width, height, maxDimension = MAX_DIMENSION) => {
    const largest = Math.max(width, height)
    if (largest <= maxDimension) return { width: Math.round(width), height: Math.round(height) }
    const scale = maxDimension / largest
    return { width: Math.round(width * scale), height: Math.round(height * scale) }
}

// Bits-per-pixel target roughly matching common H.264 "good quality" guidance (about 8 Mbps at
// 1080p30 sits near 0.12 bpp) - scaled to whatever resolution/fps ends up chosen instead of one
// fixed bitrate that under-serves large frames and over-serves small ones.
const BITS_PER_PIXEL = 0.12
const MIN_VIDEO_BITRATE = 2000000
const MAX_VIDEO_BITRATE = 20000000

// The bpp formula alone can undershoot what the *source* already had - a modest resolution like a
// 576x1024 phone clip lands around 2-2.5Mbps by bpp, well under a 3.3Mbps original, and fine detail
// (small on-screen text baked into the footage is the most visible case) noticeably softens versus
// the upload the user started from. sourceBitrate (probed straight from the source's own container,
// see probeFrameRate.js) is used as a floor so re-encoding never knowingly quality-downgrades it.
export const computeVideoBitrate = (width, height, fps, sourceBitrate = 0) => {
    const raw = width * height * fps * BITS_PER_PIXEL
    const target = Math.max(raw, sourceBitrate)
    return Math.round(Math.min(Math.max(target, MIN_VIDEO_BITRATE), MAX_VIDEO_BITRATE))
}

export const AUDIO_BITRATE = 160000

// Reduces blur/aliasing introduced whenever a frame gets scaled (cover-fit, crop upscale,
// transitions) - the 2D canvas context defaults to a low-effort smoothing algorithm.
export const configureHighQualityContext = (ctx) => {
    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'
}
